module.exports = __webpack_public_path__ + "static/media/previous-page.7e77da69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/previous-page.svg
// module id = 854
// module chunks = 0